const ADS = [
  'https://securepubads.g.doubleclick.net',
  'https://pazhfsrg.sag.stape.io/',
  'https://pagead2.googlesyndication.com/',
  'https://td.doubleclick.net/',
  'https://tags.cmp.tail.digital/',
  'https://bat.bing.com/bat.js',
  'https://www.clarity.ms/s/0.8.1/clarity.js',
  'https://cdn.popupsmart.com/bundle.js',
  /\.yandex\.ru/i,
  /pagead/i,
  /google-analytics/i,
  /pubads_impl\.js/i,
  /securepubads\.g\.doubleclick\.net/i,
  /safeframe\.googlesyndication\.com/i,
  /ads01\.groovinads\.com/i,
  /s\.decidata\.tv/i,
  // Facebook flakiness
  /graph\.facebook\.com/i,
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
]
const EXTENSIONS = [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i]
const TRACKING = [
  /\.clarity\.ms/i,
  /\.smartlook\.cloud/i,
  /\.hotjar\.com/i,
  /\.audienceexposure\.com/i,
  /\.googletagmanager\.com/i,
  /\.fullstory\.com/i,
]
const UTILS = [
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
]
const denyUrls = [...ADS, ...TRACKING, ...EXTENSIONS, ...UTILS]

export default denyUrls
